export type ValidateFn = (value: string) => boolean

export type Validate = {
  message: string
  fn: ValidateFn
}

export type ValidateParams = {
  name: string
  value: string
  rules: Validate[]
}

export function validate(name: string, value: string, rules: Validate[]) {
  const error: Record<string, string> = {}
  for(let i = 0; i < rules.length; i++) {
    const rule = rules[i]
    const hasError = rule.fn(value)
    if(hasError) {
      error[name] = rule.message
      break
    }
  }
  return error
}

export function validateList(list: ValidateParams[]) {
  const error: Record<string, string> = {}
  list.forEach(item => {
    const result = validate(item.name, item.value, item.rules)
    if(result[item.name]) {
      error[item.name] = result[item.name]
    }
  })
  return error
}
